import React from "react";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { AppBadges } from "@/components/AppBadges";
import { LINKEDIN_COMPANY } from "@/lib/site";
import { useAuth } from "@/context/AuthContext";

// g: true → guest-only SEO/marketing link (hidden from signed-in users).
const cols = [
  { title: "Platform", links: [["Talent", "/talent"], ["Opportunities", "/opportunities"], ["Jobs", "/jobs"], ["Sales Jobs Near Me", "/sales-jobs/near-me", true]] },
  { title: "For Employers", links: [["Hire Sales Reps", "/hire-sales-reps", true], ["Hire Roofing Reps", "/hire-sales-reps/roofing", true], ["Hire Solar Reps", "/hire-sales-reps/solar", true], ["Job Description Writer", "/job-description-generator", true], ["Free Hiring Badge", "/hiring-badge", true]] },
  { title: "Free Tools", links: [["Career & Money Horoscope", "/career-horoscope", true], ["New to Sales? Start Here", "/new-to-sales", true], ["How to Get Into Sales", "/how-to-get-into-sales", true], ["C.O.R.E. Sales Assessment", "/core-assessment", true], ["Closer Quiz", "/closer-quiz", true], ["What Kind of Salesperson Am I?", "/what-kind-of-salesperson-am-i", true, true], ["Sales Strengths Test", "/sales-strengths-test", true, true], ["Should I Go Into Sales?", "/should-i-go-into-sales", true, true], ["Sales Job Sites Compared", "/best-sales-job-sites", true, true], ["Sales Career Guides", "/guides", true], ["Income Calculator", "/sales-income-calculator", true], ["Sales Pay Report 2026", "/sales-pay-report", true]] },
  { title: "Company", links: [["About", "/about"], ["Pricing", "/pricing"], ["Blog", "/connie-connection"], ["Suggestion Box", "/connie-connection/suggestion-box"], ["Contact", "/"]] },
  { title: "Legal", links: [["Privacy", "/privacy"], ["Terms", "/terms"]] },
];

export default function Footer() {
  const { user } = useAuth();
  const visibleCols = cols
    .map((c) => ({ ...c, links: c.links.filter(([, , g]) => !g || !user) }))
    .filter((c) => c.links.length > 0);
  return (
    <footer className="border-t border-white/10 bg-slate-950/40" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 py-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Logo />
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
            The first in-home sales hiring platform, connecting home-improvement companies with elite one-call-close closers.
          </p>
          <a href={LINKEDIN_COMPANY} target="_blank" rel="noopener noreferrer" aria-label="Salesman Connect on LinkedIn" data-testid="footer-linkedin"
            className="inline-flex items-center gap-2 mt-4 text-sm text-slate-400 hover:text-violet-400 transition-colors">
            <Linkedin className="w-5 h-5" /> LinkedIn
          </a>
          <AppBadges className="mt-6" size="sm" label="Get the app" />
        </div>
        {visibleCols.map((c) => (
          <div key={c.title}>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-4">{c.title}</h4>
            <ul className="space-y-3">
              {c.links.map(([label, to, , ext]) => (
                <li key={label}>
                  {ext ? (
                    <a href={to} className="text-sm text-slate-400 hover:text-violet-400 transition-colors">{label}</a>
                  ) : (
                    <Link to={to} className="text-sm text-slate-400 hover:text-violet-400 transition-colors">{label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Salesman Connect. All rights reserved.
      </div>
    </footer>
  );
}
